import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { Language } from '../../../core/i18n/constants';
import { makeAuthenticatedMutator } from '../../../core/requests/auth0-bearer-auth-mutator';
import { Options } from '../../../core/requests/anonymous-mutator';

export type MutationOptions<TData = unknown, TPayload = unknown> = {
  options?: Omit<UseMutationOptions<TData, unknown, TPayload, unknown>, 'mutationFn'>;
  url: string;
  method: Options['method'];
  bodyType?: Options['bodyType'];
  language: Language;
  retrieveAccessToken: () => Promise<string>;
};

export function useBaseAuthenticatedMutation<TData, TPayload>({
  url,
  options,
  method,
  bodyType,
  language,
  retrieveAccessToken,
}: MutationOptions<TData, TPayload>) {
  const mutationFn = makeAuthenticatedMutator<TData, TPayload>({
    url,
    method,
    bodyType,
    language,
    retrieveAccessToken,
  });

  return useMutation({ ...options, retry: false, mutationFn });
}
